import { NomadDB } from '~/db/NomadDB.js';

export const getEventsService = (db: NomadDB) => {
  const findAll = async (): Promise<EventSchema[]> => {
    return await db.events.toArray();
  };

  const findAllNext = async (): Promise<EventSchema[]> => {
    return await db.events.toArray();
  };

  const count = async (): Promise<number> => {
    return await db.events.count();
  };

  const get = async (params: any): Promise<EventSchema> => {
    return await db.events.get(params);
  };

  const findByIds = async (ids: string[]): Promise<EventSchema[]> => {
    return await db.events.where('id').anyOf(ids).toArray();
  };

  return {
    findAll,
    findAllNext,
    count,
    get,
    findByIds,
  };
};
